import { render } from "./PrintCreateFoodOrderStep-3.vue?vue&type=template&id=5851b9c2"
import script from "./PrintCreateFoodOrderStep-3.vue?vue&type=script&lang=js"
export * from "./PrintCreateFoodOrderStep-3.vue?vue&type=script&lang=js"

import "./PrintCreateFoodOrderStep-3.vue?vue&type=style&index=0&id=5851b9c2&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__